import angular from 'angular';
export default angular.module('eeComUiApp.wireframe', [])
    .component('wireframe', {
    template: require('./wireframe.html'),
    controller: function ($rootScope, $state) {
        'ngInject';
        this.isLoading = function () {
            return $rootScope.loading;
        };
        this.getOptions = function () {
            return ($state.current.wireframeOptions || {});
        };
    }
})
    .name;
//# sourceMappingURL=index.js.map